var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCorrect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_379_83764)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.92969,
    y: 2,
    width: 20,
    height: 20,
    rx: 4,
    fill: "#007FAD"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_379_83764)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.80469 12.75L11.4297 15.375L17.4297 9.375",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_379_83764"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.92969,
    y: 2,
    width: 20,
    height: 20,
    rx: 4,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_379_83764"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(6.92969 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorrect);
export default __webpack_public_path__ + "static/media/correct.dccc89c22ef17751570dbaf368b72c48.svg";
export { ForwardRef as ReactComponent };